export default "__VITE_ASSET__BFhLsYDM__"